export const Colors = {
  White: '#ffffff',
  Black: '#000000',
  Blue: '#42619d',
  LightBlue: '#3f6dc5',
  Red: '#ff3b3b',
  DarkRed: '#d00f0f',
  Green: '#90ffcb',
  DarkGreen: '#56c893',
  DarkGray: '#5c5c5c',
  DarkerGray: '#898989',
  Gray: '#939393',
  LighterGray: '#a5a5a5',
  LightererGray: '#b2b2b2',
  LightGray: '#dedede',
  LightestGray: '#e8e8e8',

  Background: '#d0d0d0',

  HeroGradient1: 'rgb(46,46,46)',
  HeroGradient2: 'rgb(75,89,117)',

  Hover: '#42619d',
}

export const Fonts = {
  Header: 'Montserrat, Arial, Helvetica, sans-serif',
  Body: '"Roboto Mono", monospace',
  Monospace: '"Roboto Mono", monospace',
}

export const FontWeights = {
  Light: '300',
  Regular: '400',
  Semibold: '600',
  Bold: '700',
}

export const Borders = {
  Radius: '4px',
  LightColor: '#a8a8a8',
  Color: '#d0d0d0',
}
